import React, { useState, useEffect } from "react";
import DashboardLayout from "../../molecules/DashboardLayout";
import { Row, Col } from "antd";
import SectionHeader from "../../molecules/SectionHeader";

import { getOrginationListService } from "./service";
import ExportAuditReportComponent from "./ExportAuditReportComponent";

export default () => {
  const [searchingText, setSearchText] = useState(null);
  const [searchingBy, setSearchBy] = useState(null);
  const [organizationList, setOrginizationList] = useState(null);
  const [totalRecord, setTotalRecord] = useState(0);
  const [orgId, setOrgId] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [exportReport, setExportReport] = useState(false);

  let initialSearchKeys = [
    { value: "userName", label: "User Name" },
    { value: "portal", label: "Portal Name" },
  ];

  const orgList = async () => {
    try {
      const data = await getOrginationListService();
      data.push({
        orgId: null,
        name: "All Orgnizations",
      });
      data.reverse();
      setOrginizationList(data);
    } catch (errr) {
      console.log(errr);
    }
  };

  useEffect(() => {
    orgList();
  }, []);

  return (
    <DashboardLayout>
      <Row gutter={[24, 24]}>
        <Col span={24}>
          <Row gutter={[24, 10]}>
            <Col span={24}>
              <SectionHeader
                setSearchBy={setSearchBy}
                searchingBy={searchingBy}
                setSearchText={setSearchText}
                searchingText={searchingText}
                searchOptions={initialSearchKeys}
                organizationList={organizationList}
                paymentReports={true}
                exportAction={true}
                heading={"Export Logs"}
                total={totalRecord}
                noBorder={false}
                setOrgId={setOrgId}
                requiredOrgOptions={true}
                setStartDate={setStartDate}
                setEndDate={setEndDate}
                setExportReport={setExportReport}
              />
            </Col>

            <ExportAuditReportComponent
              setTotalRecord={setTotalRecord}
              totalRecord={totalRecord}
              searchText={searchingText}
              searchingBy={searchingBy}
              orgId={orgId ? orgId?.label?.toLowerCase() : orgId}
              startDate={startDate}
              endDate={endDate}
              setExportReport={setExportReport}
              exportReport={exportReport}
              isLoginReport={false}
            />
          </Row>
        </Col>
      </Row>
    </DashboardLayout>
  );
};
